import { useFormikContext } from 'formik';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Pagination } from 'semantic-ui-react';

import { Spinner } from '../BaseUI';
import { MessageModal } from '../shared';
import ProfilesList from './ProfilesList';

const MAX_PAGES = 3;

const Subscribers = ({
  profiles,
  isLoadingSubscriberDirectory,
  totalPages,
  descriptionField,
  currentUserId,
}) => {
  const { values, setFieldValue } = useFormikContext();
  const [messageUser, setMessageUser] = useState(null);

  const handlePageChange = (_e, data) => {
    setFieldValue('page', data.activePage);
  };

  const navigate = useNavigate();

  const isFirstPage = values.page === 1;
  const isLastPage = values.page >= totalPages || values.page >= MAX_PAGES;
  return (
    <div className="list-wrapper">
      {isLoadingSubscriberDirectory ? (
        <Spinner />
      ) : (
        <>
          <ProfilesList
            currentUserId={currentUserId}
            descriptionField={descriptionField}
            navigate={navigate}
            profiles={profiles}
            setMessageUser={setMessageUser}
          />
          <MessageModal user={messageUser} onClose={() => setMessageUser(null)} />
        </>
      )}
      <React.Fragment key={values.page}>
        {!isLoadingSubscriberDirectory && totalPages > 1 && (
          // Pagination arrows can be custom!
          // *If undefined the default will be used, if null there will be no arrow at all
          <Pagination
            defaultActivePage={values.page}
            firstItem={isFirstPage ? null : undefined} // see note above
            nextItem={isLastPage ? null : undefined} // see note above
            prevItem={isFirstPage ? null : undefined} // see note above
            lastItem={isLastPage ? null : undefined} // see note above
            onPageChange={handlePageChange}
            size="mini"
            siblingRange={0}
            totalPages={totalPages <= MAX_PAGES ? totalPages : MAX_PAGES}
          />
        )}
      </React.Fragment>
    </div>
  );
};

export default Subscribers;
